<template lang="pug">
  #bar
    v-container(fluid)
      v-layout(row, wrap)
        v-flex(xs12)
          v-layout(column, wrap, align-center)
            p.mb-0 AGRESIONES POR ESTADO
            svg
              //svg(width="550", height="625")
</template>

<script>
import * as d3 from "d3";

export default {
  name: "Bar",
  data() {
    return {
      stateColors: this.$store.state.stateColors,
      aggressionsTypes: this.$store.state.aggressionsTypes,
      labels: [],
      dataset: [],
      reports: this.$store.state.reports,
    };
  },
  watch: {
    "$store.state.reports": function (val) {
      this.dataset = [];
      this.stateColors.forEach((state) => {
        // console.log(state.name)
        let row = {};
        row.total = 0;
        this.aggressionsTypes.forEach((type) => {
          const reports = val.filter((report) => {
            if (
              state.name === "Ciudad de México" &&
              report.state === "CDMX" &&
              report.type === type.title
            ) {
              return true;
            }
            return (
              state.name.trim() === report.state && type.title === report.type
            );
          });
          row[type.title] = reports.length;
          row.total += reports.length;
        });
        row.state = state.alias;
        // console.log(row)
        this.dataset.push(row);
      });

      // console.log(this.labels);
      //console.log(this.dataset, "this dataset");

      this.drawBar();
    },
  },
  /*props: {
  },
  computed: {
    reports: function () {
      return this.$store.state.reports;
    }
  },
  watch: {
    reports: function (val) {
      this.stateColors.forEach(state => this.labels.push(state.name))
      this.aggressionsTypes.forEach(type => {
        // console.log(state.name)
        let data = []
        this.stateColors.forEach(state => {
          const reports = this.reports.filter(report => {
            if(state.name === "Ciudad de México" && report.state === "CDMX" && report.type === type.title) {
              return true
            }
            return state.name.trim() === report.state && type.title === report.type
          })
          data.push(reports.length)
        })
        // console.log(data)
        this.dataset.push({
          label: type.title,
          backgroundColor: type.color,
          borderColor: type.color,
          borderWidth: 2,
          data: data
        })
      })
    }
  }*/
  methods: {
    drawBar() {
      console.log("draw var");
      d3.select("#bar").selectAll("svg").remove();
      const svg = d3
        .select("#bar")
        .append("svg")
        .attr("width", 550)
        .attr("height", 625);
      //const svg = d3.select("#bar svg");
      const margin = { top: 20, right: 20, bottom: 30, left: 120 };
      const height = +svg.attr("width") - margin.left - margin.right;
      const width = +svg.attr("height") - margin.top - margin.bottom;
      const g = svg
        .append("g")
        .attr("transform", "translate(" + 500 + "," + 50 + ") rotate(90)");

      const x = d3
        .scaleBand()
        .rangeRound([0, width])
        .paddingInner(0.05)
        .align(0.1);

      const y = d3.scaleLinear().rangeRound([height, 0]);

      const z = d3
        .scaleOrdinal()
        .range([
          "#98abc5",
          "#8a89a6",
          "#7b6888",
          "#6b486b",
          "#a05d56",
          "#d0743c",
          "#ff8c00",
        ]);

      const data = this.dataset;

      const keys = this.labels.slice(1);

      data.sort(function (a, b) {
        return b.total - a.total;
      });
      x.domain(
        data.map(function (d) {
          return d.state;
        })
      );
      y.domain([
        0,
        d3.max(data, function (d) {
          return d.total;
        }),
      ]).nice();
      z.domain(keys);

      g.append("g")
        .selectAll("g")
        .data(d3.stack().keys(keys)(data))
        .enter()
        .append("g")
        .attr(
          "fill",
          (d) =>
            this.aggressionsTypes.filter((type) => type.title === d.key)[0]
              .color
        )
        .selectAll("rect")
        .data(function (d) {
          return d;
        })
        .enter()
        .append("rect")
        .attr("x", function (d) {
          return x(d.data.state) + 5;
        })
        .attr("y", function (d) {
          return y(d[1]);
        })
        .attr("height", function (d) {
          return y(d[0]) - y(d[1]);
        })
        .attr("width", x.bandwidth() / 2);

      g.append("g")
        .attr("class", "axis")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x))
        .selectAll("text")
        .attr("y", 0)
        .attr("x", -10)
        .attr("dy", ".35em")
        .attr("transform", "rotate(270)")
        .style("text-anchor", "end")
        .style("fill", "white")
        .style("font", "bold 14px Rajdhani, sans-serif");

      g.append("g")
        .attr("class", "axis")
        .attr("transform", "translate(560,0)")
        .call(d3.axisRight(y).ticks(null, "s").tickSize(-width, 0, 0))
        .selectAll("text")
        .attr("y", 10)
        .attr("x", 15)
        .attr("dy", ".35em")
        .attr("transform", "rotate(270)")
        .style("text-anchor", "start")
        .style("fill", "white")
        .style("font", "bold 14px Rajdhani, sans-serif");
      /*.append("text")
          .attr("x", 2)
          .attr("y", y(y.ticks().pop()) + 0.5)
          .attr("dy", "0.32em")
          .attr("fill", "#000")
          .attr("font-weight", "bold")
          .attr("text-anchor", "start")
          .text("Agresiones registradas")*/ d3.selectAll(
        ".axis"
      )
        .select("path")
        .style("stroke", "#ffffff33");

      d3.selectAll(".axis").selectAll("line").style("stroke", "#ffffff33");
    },
  },
  mounted() {
    this.aggressionsTypes.forEach((type) => this.labels.push(type.title));
    this.labels.unshift("state");
    this.stateColors.forEach((state) => {
      // console.log(state.name)
      let row = {};
      row.total = 0;
      this.aggressionsTypes.forEach((type) => {
        const reports = this.reports.filter((report) => {
          if (
            state.name === "Ciudad de México" &&
            report.state === "CDMX" &&
            report.type === type.title
          ) {
            return true;
          }
          return (
            state.name.trim() === report.state && type.title === report.type
          );
        });
        row[type.title] = reports.length;
        row.total += reports.length;
      });
      row.state = state.alias;
      // console.log(row)
      this.dataset.push(row);
    });

    // console.log(this.labels);
    // console.log(this.dataset);

    this.drawBar();
  },
};
</script>

<style scoped lang="scss">
#bar {
  p {
    font-family: "Rajdhani", sans-serif;
    color: white;
    font-size: 30px;
    font-weight: 700;
  }
}
</style>
